// extracted by mini-css-extract-plugin
module.exports = {"printable":"styles_base_printable__ZDzut","nonPrintable":"styles_base_nonPrintable__N6Kkl"};